import { message } from "antd";
import LoginApi from "../api/LoginApi";
import { NAME_TOKEN } from "./../shared/constants";

export default {
  login: async (MSSOResponse) => {
    const response = await LoginApi.login(MSSOResponse);
    // Almacenar el token en localStorage
    if (response.success) {
      localStorage.setItem(NAME_TOKEN, response.data.token);
      message.success("Bienvenido");
    } else {
      message.error(response.message);
    };

    return response;
  }, 
  checkToken: async (token) => {
    const response = await LoginApi.checkToken(token);
    if (!response.success) {
      message.error(response.message);
      localStorage.removeItem(NAME_TOKEN);
    };
    return response;
  }, 
};
